<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowAudiologistToPhysicianRatio',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_providers', throughMonth),
          this.getYtdByField(yearObj, 'number_physicians', throughMonth),
          0,
        );
      },
    },
  };
</script>
